import { Button, Modal } from '@mairistem/composants';
import React from 'react';
import useModalSuperUserValidation from '../../../../../hooks/useModalSuperUserValidation';
import type { BordereauWithState } from '../../../../../interfaces/pieces/TreeRow';

interface BordereauForcePriseEnChargeModalProps {
	onChange: (data: BordereauWithState) => void;
	onClose: VoidFunction;
	isSuperUser: boolean;
	visible: boolean;
	bordereau: BordereauWithState;
}

const BordereauForcePriseEnChargeModal = ({
	onClose,
	onChange,
	visible,
	bordereau,
	isSuperUser,
}: BordereauForcePriseEnChargeModalProps) => {
	const { isValidated, validationComponent } = useModalSuperUserValidation();

	const handleClick = (): void => {
		onChange(bordereau);
		onClose();
	};

	return (
		<Modal
			closeIcon
			open={visible}
			onClose={onClose}
			data-testid="bordereauForcePriseEnChargeModal"
		>
			<Modal.Header>
				Considérer le bordereau comme traité par la DGFIP
			</Modal.Header>
			<Modal.Content>
				Vous souhaitez considérer que les mouvements de ce bordereau sont déjà
				pris en charge par le comptable, sans attendre les informations
				transmises automatiquement par les flux PES Retour de la DGFiP.”
				{isSuperUser && validationComponent}
			</Modal.Content>
			<Modal.Actions>
				<Button
					onClick={onClose}
					data-testid="bordereauForcePriseEnChargeModalCancel"
				>
					Annuler
				</Button>
				<Button
					disabled={isSuperUser && !isValidated}
					primary
					onClick={handleClick}
					data-testid="bordereauForcePriseEnChargeModalConfirm"
				>
					Confirmer
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

export default BordereauForcePriseEnChargeModal;
